export const actionTypes = {
    DOMAIN : 'PROFILE_ACTIONS',
    SAVE_PROFILE : 'SAVE_PROFILE'
}